<template>
  <ul class="menu-sublevel" :class="customClasses">
    <TheMenuSubitem v-for="item in items" :key="item.text" :content="item" />
  </ul>
</template>

<script>
import TheMenuSubitem from './TheMenuSubitem'

export default {
  name: 'TheMenuSublevel',
  props: {
    items: {
      type: Array,
      required: true,
      validator: (items) => {
        return (items.length > 0)
      }
    },
    position: {
      type: String,
      required: false,
      default: 'left',
      validator: (position) => {
        return position === 'left' || position === 'right'
      }
    }
  },
  computed: {
    customClasses () {
      return [
        `is-${this.position}`
      ]
    }
  },
  components: {
    TheMenuSubitem
  }
}
</script>

<style lang="scss">
  .menu-sublevel{
    @include no-type-list;
    @include media("small-medium"){
      width: 100%;
      z-index: 0;
    }
    @include media("large"){
      transform: translateY(100%);
      position: absolute;
      bottom: -1rem;
      padding: layout("spacing")*0.1;
    }

    min-width: 22rem;
    border-radius: .5rem;
    background-color: colors(foreground);

    &.is-left{
      left: 0;
    }

    &.is-right{
      right: 0;
    }
  }
</style>
